import OlMap from '@m1/ol-map';
import classNames from 'classnames/bind';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FunctionButton } from '@/components/ui/kit/Button';
import Checkbox from '@/components/ui/kit/Checkbox';
import Select from '@/components/ui/kit/Select';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const MapView = ({ robotId }) => {
  const dispatch = useDispatch();
  const robotOptions = useSelector((state) => state.robotOptions[robotId]);
  const focusRobotId = useSelector((state) => state.robot.focusRobotId);

  const toggleVisible = (key) => {
    dispatch(actions.robotOptions.toggleVisible(robotId, key));
  };

  const toggleFocus = () => {
    // 지도 내 해당 로봇 마커 존재하지 않는 경우
    if (!OlMap.getMap().getOverlayById(`robots/${robotId}`)) {
      notifier.error('Location has not been defined yet.');
      return;
    }

    if (focusRobotId === robotId) {
      dispatch(actions.robot.setFocus());
    } else {
      dispatch(actions.robot.setFocus(robotId));
    }
  };

  const changeTraceType = (e) => {
    dispatch(actions.robotOptions.changeTraceType(robotId, e.target.value));
  };

  const resetTraceAndShoots = () => {
    OlMap.shoot.remove(robotId);
    OlMap.trace.reset(robotId);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('title')}>Map View</div>
      <div className={cx('box')}>
        <FieldRow label="Center on Robot" height={24}>
          <Checkbox checked={focusRobotId === robotId} onClick={toggleFocus} />
        </FieldRow>
        <FieldRow label="Show Label" height={24}>
          <Checkbox checked={robotOptions.label.visible} onClick={() => toggleVisible('label')} />
        </FieldRow>
        <FieldRow label="Show Trace" height={24}>
          <Checkbox checked={robotOptions.trace.visible} onClick={() => toggleVisible('trace')} />
        </FieldRow>
        <FieldRow label="Trace Type">
          <Select
            value={robotOptions.trace.type}
            onChange={changeTraceType}
            disabled={!robotOptions.trace.visible}
            className={cx('select')}>
            <option value="full">Full</option>
            <option value="recent">Recent</option>
          </Select>
        </FieldRow>
        <FieldRow label="Reset Trace & Shoots">
          <FunctionButton text="Reset" type="small" className={cx('button')} onClick={resetTraceAndShoots} />
        </FieldRow>
      </div>
    </div>
  );
};

export default MapView;
